<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <text class="title">{{$route.meta.title}}
        <span style="font-weight: normal" v-if="infoDetailID">(您的作品已提交成功)</span>
        <span style="font-weight: normal" v-else>(您已报名成功，请在截止时间前上报您的作品)</span>
      </text>
     <div v-if="infoDetailID">
       <el-button type="primary" class="ms-2 me-3"  @click="handleWordPreview">作品查看 </el-button>
     </div>
    </div>
    <div class="pub-center">
      <div class="shadow-sm bg-white px-3 py-2">
        <p class="small text-danger text-start mb-1">注意事项：</p>
        <p class="small text-danger text-start mb-1">1）知识产权：请在“参赛文件下载”中下载模板并填写签名后扫描上传；</p>
        <p class="small text-danger text-start mb-1">2）可行性报告：请在文件下载中下载模板并填写后上传;</p>
        <p class="small text-danger text-start mb-1">3）在作品提交截止时间之前，可以多次提交修改作品材料，点击“提交”按钮后，自动覆盖前次提交的材料;</p>
      </div>
      <div class="shadow-sm bg-white px-3 py-2 my-2 d-flex align-items-center justify-content-center">
        <el-form :disabled="!can_submit" :loading="infoLoading" :model="form" :rules="rules" size="large" label-width="auto" style="width: 100%;max-width: 1000px" ref="ruleFormRef">
          <el-row :gutter="10" justify="space-between" class="mt-3 mb-4">
            <el-col :span="24" v-if="infoDetailID">
              <div class="fs-3 my-4 fw-bold ">您的作品编号：{{infoDetailID}}</div>
            </el-col>
            <el-col :span="4" >参赛年份：{{userInfo.Year}}</el-col>
            <el-col :span="8" >省份：{{userInfo.Province}}</el-col>
            <el-col :span="8" >参赛学校：{{userInfo.School}}</el-col>
            <el-col :span="4" >参赛组别：{{userInfo.LevelName}}</el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" >
              <el-form-item label="作品名称：" prop="Name" >
                <el-input v-model="form.Name" placeholder="请填写"/>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="作品简介：" prop="Description" >
                <el-input v-model="form.Description" type="textarea" maxlength="300" rows="10" show-word-limit placeholder="请填写"/>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="选题类型：" prop="TopicId" >
                <el-select v-model="form.TopicId" placeholder="请选择">
                  <el-option v-for="op of topics" :key="op.ID" :label="op.Name" :value="op.ID" />
<!--                  <el-option label="Zone two" value="beijing" />-->
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="关键字：" prop="Keywords" >
                <el-input-tag
                    :trigger="'Space'"
                    :max="5"
                    v-model="form.Keywords"
                    placeholder="请输入关键字(限5个，按空格分隔)"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="项目可行性报告：" prop="Feasibility">
                <el-upload
                    style="width: 400px;text-align: start"
                    v-model:file-list="fileList"
                    :action="VUE_APP_uploadurl"
                    :before-upload="($event)=>beforeUpload($event,'Feasibility',10,'application/pdf')"
                    :data="uploadData['Feasibility']"
                    :on-preview="handlePreviewPdf"
                    :on-remove="handleRemove"
                    :on-exceed="masterFileMax"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :limit="1"
                    accept="application/pdf"
                    multiple
                >
                  <el-button type="primary" size="middle" plain class="px-4" >上传</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="margin-top: 0">
                      请在“参赛文件下载”中下载模板并填写后上传（pdf,10MB以内）
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="项目汇报视频：" prop="Video" >
                <el-upload
                    style="width: 400px;text-align: start"
                    v-model:file-list="fileList2"
                    :action="VUE_APP_uploadurl"
                    :before-upload="($event)=>beforeUpload($event,'Video',100,'video/mp4')"
                    :data="uploadData['Video']"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-exceed="masterFileMax"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :limit="1"
                    multiple
                    accept="video/mp4"
                >
                  <el-button type="primary" size="middle" plain class="px-4" >上传</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="margin-top: 0">
                      以ppt的形式汇报，并录制视频上传，时间不超过6分钟（MP4,100MB以内）
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="知识产权声明：" prop="Ip" >
                <el-upload
                    style="width: 400px;text-align: start"
                    v-model:file-list="fileList3"
                    :action="VUE_APP_uploadurl"
                    :before-upload="($event)=>beforeUpload($event,'Ip',5,'application/pdf')"
                    :data="uploadData['Ip']"
                    :on-preview="handlePreviewPdf"
                    :on-remove="handleRemove"
                    :on-exceed="masterFileMax"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :limit="1"
                    accept="application/pdf"
                    multiple
                >
                  <el-button type="primary" size="middle" plain class="px-4" >上传</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="margin-top: 0">
                      请在“参赛文件下载”中下载模板并填写签名后扫描上传（pdf,5MB以内）
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col :span="24" >
            <el-form-item label="创新性描述：" prop="Innovation" >
              <el-input v-model="form.Innovation" type="textarea" placeholder="请输入创新性描述（限300字）" maxlength="300" rows="10" show-word-limit/>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="产业应用描述：" prop="Industry" >
              <el-input v-model="form.Industry" type="textarea" placeholder="请输入产业应用描述（限300字）" maxlength="300" rows="10" show-word-limit/>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="社会经济效益：" prop="Benefits" >
              <el-input v-model="form.Benefits" type="textarea" placeholder="请输入可取得的经济效益或社会效益（限500字）" rows="10" maxlength="500" show-word-limit/>
            </el-form-item>
          </el-col>

          <div class="w-100  d-flex align-items-center justify-content-center flex-column my-4">
            <el-button type="primary" class="px-5"
                       v-loading="loading"
                       :disabled = "incompleteInfo"
                       @click="save"
            >提交
            </el-button>
            <el-button type="danger" text class="mt-2" v-if="!can_submit">当前时间段已截止提交作品</el-button>
            <div class="small text-secondary mt-3">在作品提交截止时间之前，可以多次提交修改作品材料，点击“提交”后，自动覆盖前次提交的材料。</div>
          </div>
        </el-form>

      </div>
    </div>

  </div>
<!-- 抽屉-->
  <el-drawer v-model="drawer" title="已上传作品预览" size="100%">
    <div >
        <EntryPreview v-if="drawer"></EntryPreview>
    </div>
  </el-drawer>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import EntryPreview from "@/components/EntryPreview"
import {getQiniuPrivateUploadToken} from "@/api/commonApi";
let qianniuInfo = null // 千牛上传凭证
const uploadData = reactive({"Feasibility":{key:"",token:""},"Video":{key:"",token:""},"Ip":{key:"",token:""},})
const VUE_APP_uploadurl = "https://upload-z2.qiniup.com" // 七牛地址
import {useStore} from "vuex";
import { useRouter } from "vue-router";
import {getName, LEVELS} from "@/utils/commonSetting";
import {validateForm} from "@/utils/formValidate";
import {addWork, genPreviewurl, getTopics, getWork, updateWork} from "@/api/student";
const store = useStore()
let router = useRouter();
const userInfo = ref({})
const loading = ref(false) // 保存信息
const infoLoading = ref(false) // 获取信息
const incompleteInfo = ref(true)
const ruleFormRef = ref()
const topics = ref([])
const drawer = ref(false)
const can_submit = computed(()=>store.state.sysModel.can_submit) // 是否可提交

const form = reactive({
  Name:null,// string, // 作品名称
  Description:null,// string // 作品简介
  TopicId:null,// int // 选填类型
  Keywords:null,// string // 关键词. 限制5个，逗号分隔
  Feasibility:null,// string // 项目可行性报告 文件
  Video:null,// string // 项目汇报视频 文件
  Ip:null,// string // 知识产权声明 文件
  Innovation:null,// string // 创新性描述
  Industry:null,// string // 产业应用描述
  Benefits:null,// string // 社会经济效益，
})
const infoDetailID = ref()

const rules = ({
  Name: [
    {required: true, message: '请输入作品名称', trigger: ['change','blur']},
  ],
  Description: [{required: true, message: '请输入作品简介', trigger: ['change','blur']}],
  TopicId: [
    {required: true, message: '请选择选题类型', trigger: ['change','blur']},
  ],
  Keywords: [
    {required: true, message: '请输入关键词', trigger: ['change','blur']},
  ],
  Feasibility: [
    {required: true, message: '请上传项目可行性', trigger: ['change','blur']},
  ],
  Video: [
    {required: true, message: '请上传汇报视频', trigger: ['change','blur']},
  ],
  Ip: [
    {required: true, message: '请上传知识产权声明', trigger: ['change','blur']},
  ],
  Innovation: [
    {required: true, message: '请输入创新性描述', trigger: ['change','blur']},
  ],
  Industry: [
    {required: true, message: '请输入产业应用描述', trigger: ['change','blur']},
  ],
  Benefits: [
    {required: true, message: '请输入社会经济效益', trigger: ['change','blur']},
  ],
})

const fileList = ref([])
const fileList2 = ref([])
const fileList3 = ref([])
onMounted(()=>{
  getSettingFun() // 获取配置信息
  getWorkFun() // 获取当前参赛队伍的信息
  getUserInfo()// 获取用户信息
  getTopicList()// 获取选题类型
  // getQiniuPrivateUploadTokenFun() // 获取上传凭证
})
// 获取配置信息
const getSettingFun =async ()=>{
  infoLoading.value = true
  await store.dispatch("sysModel/getAllsettingsFun") // 获取系统配置
  infoLoading.value = false
}
// 获取当前参赛队伍信息
const getWorkFun = async ()=>{
  infoLoading.value = true
  const res =await getWork()
  infoLoading.value = false
  if(res.err_code==0){ // 有数据
    const data = res.data || {}
    form.Name = data.Name
    form.Description = data.Description
    form.TopicId = data.TopicId
    form.Keywords = data.Keywords?data.Keywords.split(","):null
    form.Feasibility = data.Feasibility
    form.Video = data.Video
    form.Ip = data.Ip
    form.Innovation = data.Innovation
    form.Industry = data.Industry
    form.Benefits = data.Benefits
  //  设置页面文件
    let filesName;
    if(data.Feasibility){
      filesName = data.Feasibility.split("/").reverse()[0]
      fileList.value = [{name:filesName,response:{key:data.Feasibility},status:"success"}]
    }
    if(data.Video){
      filesName = data.Video.split("/").reverse()[0]
      fileList2.value = [{name:filesName,response:{key:data.Video},status:"success"}]
    }
    if(data.Ip){
      filesName = data.Ip.split("/").reverse()[0]
      fileList3.value = [{name:filesName,response:{key:data.Ip},status:"success"}]
    }
    infoDetailID.value = data.ID
  }else{ // 未填报数据，不做处理
    infoDetailID.value = null
  //   todo
  }

}
// 获取选题
const getTopicList = async ()=>{
  const res = await getTopics()
  if(res.success){
    topics.value = res.data || []
  }

}
// 获取用户信息
const getUserInfo = async  ()=>{
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  const u = store.getters["loginModel/getUserInfo"] || {}
  if(u.University){
    u.Province = u.University.Province
    u.School = u.University.Name
  }
  if(u.Level){
    u.LevelName = getName(LEVELS,u.Level)
  }
  userInfo.value = u
  incompleteInfo.value = store.getters["loginModel/getStudentInfoIncomplete"]
  if(incompleteInfo.value){
    return  ElMessageBox.alert('请补充参赛队信息后再上传作品，去补充？', '补充信息', {
      confirmButtonText: '确定',
      callback: (action) => {
        if(action==='confirm'){ // 确定
          router.push({path:'/student/teams'})
        }
      },
    })
  }
}
// 上传之前判断
const beforeUpload = async(rawFile,key,limit,type)=>{
  if(!rawFile)return
  if(rawFile.type !==type){
      ElMessage.error(`请上传指定格式的文件!`);
    return
  }
  const isLt = rawFile.size / 1024 / 1024 < limit;
  if (!isLt) {
    ElMessage.error(`不能大于${limit}MB!`);
    return false
  }
  // 处理文件名称
  let fileNameFull = rawFile.name,dealName;
  const files = fileNameFull.split(".") || []
  const fileType = files.splice(-1,) || []
  const fileName = files.join(".")
  if(fileName && fileType[0] ){
    dealName = fileName + "_"+new Date().getTime()+"." + fileType[0]
  }else{
    dealName = new Date().getTime()
  }
  dealName = dealName.replace(/;/g,"") // 替换掉英文的;
  let binary = new FormData()
  binary.append('file',rawFile)
  binary.append('name',rawFile.name)
  qianniuInfo = await getQiniuPrivateUploadTokenFun() // 先获取千牛上传的凭证
  if(!qianniuInfo){
    return  ElMessage.error('无法上传')
  }
  uploadData[key] = {
    key:`${qianniuInfo.filePrefix}/${dealName}`,
    token:qianniuInfo.uploadToken
  }
}
// 获取千牛上传凭证
const getQiniuPrivateUploadTokenFun =  () => {
  if(qianniuInfo && qianniuInfo.uploadToken){
    return Promise.resolve(qianniuInfo)
  }
  return getQiniuPrivateUploadToken().then(res=>{
    if(res.errCode===0){
      qianniuInfo = res
    }else{
      qianniuInfo = null
    }
    return Promise.resolve(res)
  })
}
// 文件上传
const masterFileMax = ()=>{
  ElMessage.warning("数量超出限制！")
}
const handleUploadError= (err)=>{
  ElMessage.error(err.error || "上传失败")
  // console.log(999,err)
}
const handleUploadSuccess = (res)=>{
  console.log(888,res,fileList.value)
}

const handleRemove = () => {

}
// 预览视频
const handlePreview =async (item)=>{
  let name;
  if(item.response && item.response.key){
     name = item.response.key.split("/").reverse()[0]
  }
  if(!name){
    return ElMessage.warning("无法预览")
  }else{
    const res = await genPreviewurl({filename:name})
    if(res.err_code===0 && res.data){
      const url = res.data
      window.open(url,"_blank") // 浏览器直接打开
    }else{
      return ElMessage.warning("无法预览")
    }
  }



}
// 预览pdf
const handlePreviewPdf =async (item)=>{
  let name;
  if(item.response && item.response.key){
    name = item.response.key.split("/").reverse()[0]
  }
  if(!name){
    return ElMessage.warning("无法预览")
  }else{
    const res = await genPreviewurl({filename:name})
    if(res.err_code===0 && res.data){
      const url = res.data
      window.open(url,"_blank") // 浏览器直接打开
    }else{
      return ElMessage.warning("无法预览")
    }
  }
}
const save = async ()=>{
  if(fileList.value && fileList.value.length>0){
    if(fileList.value[0].status === "success" && fileList.value[0].response){
      form.Feasibility = fileList.value[0].response.key
    }else{
      form.Feasibility = ""
    }
  }
  if(fileList2.value && fileList2.value.length>0){
    if(fileList2.value[0].status === "success" && fileList2.value[0].response){
      form.Video = fileList2.value[0].response.key
    }else{
      form.Video = ""
    }
  }
  if(fileList3.value && fileList3.value.length>0){
    if(fileList3.value[0].status === "success" && fileList3.value[0].response){
      form.Ip = fileList3.value[0].response.key
    }else{
      form.Ip = ""
    }
  }
  const isValid = await validateForm(ruleFormRef.value)
  if (!isValid) {
    return ElMessage.warning("无法提交，请检查您是否有未填项")
  }
  loading.value = true
  let res,  params = {...form,Keywords:form.Keywords?form.Keywords.join(","):""}
  // params = {
  //   Name: "%E4%BD%9C%E5%93%81%E5%90%8D%E7%A7%B0",
  // Description: "text",
  // TopicId: 4,
  // Keywords: "222",
  // Feasibility: "competition%2Fwork%2F3%2F%E7%BB%84%20372.png",
  // Video: "competition%2Fwork%2F3%2Fb34c7d1bff41b2e7d0952aa240ba7183.mp4",
  // Ip: "competition%2Fwork%2F3%2F%E7%BB%84%20372.png",
  // Innovation: "bdjsbdj",
  // Industry: "dsadasda",
  // Benefits: "asdweqweqw",
  // }
  if(infoDetailID.value){
    params.ID = infoDetailID.value
    res = await  updateWork(params)
  }else{
    res = await  addWork(params)

  }
  loading.value = false
  if (res.success) {
    // ElMessage.success("保存成功")
   await getWorkFun() // 更新信息
    ElMessageBox.confirm(
        '可点击右上角"作品查看"按钮，查看已上传作品信息',
        '保存成功',
        {
      confirmButtonText: '作品查看',
      cancelButtonText: '关闭提醒',
      type: 'success',
      callback: (action) => {
        if(action==='confirm'){ // 确定
          handleWordPreview()
        }
      },
    })
  } else {
    ElMessage.warning(res.err_msg || "保存失败")
  }
}
// 作品查看
const handleWordPreview = ()=>{
  drawer.value = true
}
</script>

<style scoped lang="scss">


</style>
